import React, { ReactElement } from 'react';
import IconBlockSuccess from '../../../components/icon-block-success/icon-block-success.component';
import IconBlockWarning from '../../../components/icon-block-warning/icon-block-warning.component';
import IconBlockExpired from '../../../components/icon-block-expired/icon-block-expired.component';
import StatusIconBlock from '../../../components/status-icon-block/status-icon-block.component';
import DateService from '../../../services/date-service';
import { DEAL_TASK_STATUS_COMPLETED, DEAL_TASK_STATUS_REJECTED } from '../../../constants/entity/deal-task-statuses';

const DealTaskStatusIcon: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const {
    withLeftOffset,
    withRightOffset,
    dealTaskData,
    className,
  } = props;

  let icon: ReactElement | null = null;
  let title: string = '';

  if (dealTaskData.status === DEAL_TASK_STATUS_COMPLETED) {
    icon = <IconBlockSuccess />;
    title = 'Completed';
  }

  if (dealTaskData.status === DEAL_TASK_STATUS_REJECTED) {
    icon = <IconBlockWarning />;
    title = 'Rejected';
  }

  if (dealTaskData.dueDate && Date.parse(dealTaskData.dueDate) < DateService.getCurrentDateTimeStamp()
    && dealTaskData.status !== DEAL_TASK_STATUS_REJECTED && dealTaskData.status !== DEAL_TASK_STATUS_COMPLETED) {
    icon = <IconBlockExpired />;
    title = 'Expired';
  }

  return (
    <StatusIconBlock
      withLeftOffset={withLeftOffset}
      withRightOffset={withRightOffset}
      title={title}
      className={className}
    >
      {icon}
    </StatusIconBlock>
  );
});

export default DealTaskStatusIcon;
